import {isSandboxOrLocalEnv} from "./environment"
import {ChoiceFinancialGroupLogo} from "../images/bankLogos/ChoiceFinancialGroupLogo"
import {BankLogoProps} from "../images/bankLogos/bankLogoUtils"
import {BlueRidgeBankLogo} from "../images/bankLogos/BlueRidgeBankLogo"
import {PiermontBankLogo} from "../images/bankLogos/PiermontBankLogo"
import {ThreadBankLogo} from "../images/bankLogos/ThreadBankLogo"
import {MvbBankLogo} from "../images/bankLogos/MvbBankLogo"

const BANKS: Record<string, BankDetails> = {
	"1": createBankDetails("Blue Ridge", BlueRidgeBankLogo),
	"2": createBankDetails("Choice Financial Group", ChoiceFinancialGroupLogo),
	"4": createBankDetails("Piermont", PiermontBankLogo),
	"5": createBankDetails("Thread", ThreadBankLogo),
	"6": createBankDetails("MVB", MvbBankLogo),
}

const SANDBOX_BANKS: Record<string, BankDetails> = {
	"1": createBankDetails("Bank"),
	"2": createBankDetails("Choice Bank", ChoiceFinancialGroupLogo),
	"16": createBankDetails("Leumi Bank"),
}

interface BankDetails {
	name: string
	logo?: (props: BankLogoProps) => JSX.Element
}

function createBankDetails(name: string, logo?: (props: BankLogoProps) => JSX.Element): BankDetails {
	return {name, logo}
}

export function getBankDetails(bankId: string): BankDetails {
	return (isSandboxOrLocalEnv() ? SANDBOX_BANKS[bankId] : BANKS[bankId]) || createBankDetails("")
}
